import { render, staticRenderFns } from "./ReportingCategory.vue?vue&type=template&id=3d5c6fc3&scoped=true"
import script from "./ReportingCategory.vue?vue&type=script&lang=js"
export * from "./ReportingCategory.vue?vue&type=script&lang=js"
import style0 from "./ReportingCategory.vue?vue&type=style&index=0&id=3d5c6fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c6fc3",
  null
  
)

export default component.exports